import React from "react";
import Header from "../../../components/Header/Header";
import LeftSideBar from "../../../components/LeftSideBar/LeftSideBar";
import { Grid, Box } from "@mui/material";
import AdministratorHeader from "../../../components/Header/AdministratorHeader";
import BatchinfoTable from "../../../components/BatchInfoTable";
import constantValues from "../../../constants/constantValues";

export default function Index() {
  const {
    PROJECT_NAME,
    BATCH_NAME,
    DOCUMENT_DETAIL,
    PRE_NAME,
    PRO_NAME,
    VAL_NAME,
    STATUS,
    BATCH_DETAILS,
    HISTORY,
  } = constantValues;

  let header = [
    PROJECT_NAME,
    BATCH_NAME,
    PRE_NAME,
    PRO_NAME,
    VAL_NAME,
    STATUS,
    DOCUMENT_DETAIL,
    HISTORY,
  ];
  return (
    <>
      <Header page="new-project" />
      <Box>
        <Grid className="sidebar-main" container>
          <Grid item className="sidebar-container">
            <LeftSideBar page="sidebar" />
          </Grid>
          <Grid item className="visualization-conatiner">
            <AdministratorHeader text={BATCH_DETAILS} />
            <Grid item md={12}>
              <BatchinfoTable header={header} />
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
